/* PR desktop mega nav. Works only if the existing Wokiee menu can be safely found. */
(function(){
  'use strict';
  if(window.__prmDesktopNavInstalled)return;
  window.__prmDesktopNavInstalled=true;
  var place=null,originalParent=null,originalNext=null,holder=null;
  var videoModal=null,videoModalReturnFocus=null,videoModalPriorOverflow=null;
  function getSection(){return document.querySelector('[data-prm-desktop-nav]');}
  function closeVideoModal(){
    if(!videoModal)return false;
    var toFocus=videoModalReturnFocus;
    videoModal.remove();
    videoModal=null;
    document.body.style.overflow=videoModalPriorOverflow===null?'':videoModalPriorOverflow;
    videoModalPriorOverflow=null;
    videoModalReturnFocus=null;
    if(toFocus&&toFocus.isConnected&&document.activeElement!==toFocus)toFocus.focus({preventScroll:true});
    return true;
  }
  function stopVideos(root){
    closeVideoModal();
    if(!root)return;
    root.querySelectorAll('[data-prm-video-player]').forEach(function(host){
      host.replaceChildren();
      host.hidden=true;
      var button=host.parentElement&&host.parentElement.querySelector('.prm-desktop-nav__video-play');
      if(button)button.hidden=false;
    });
  }
  function closeMenus(root){
    if(root)root.querySelectorAll('details[open]').forEach(function(d){d.open=false;});
    stopVideos(root);
  }
  function revert(){
    var root=getSection();
    if(holder)holder.classList.remove('prm-desktop-nav-mounted');
    if(root&&originalParent&&originalParent.isConnected){
      if(originalNext&&originalNext.parentNode===originalParent)originalParent.insertBefore(root,originalNext);
      else originalParent.appendChild(root);
    }
    if(root){closeMenus(root);root.hidden=true;}
    place=null;holder=null;
  }

  /* The mobile navigation owns the category photos and their Theme Editor
     selections. Match link titles and reuse the rendered CDN URLs, so changes
     to PR Mobile Menu update this desktop dropdown automatically. */
  function normalizeTitle(value){
    return String(value||'').replace(/\s+/g,' ').trim().toLowerCase();
  }
  function syncMobilePhotos(root){
    if(!root)return;
    var shown=root.getAttribute('data-prm-show-photos')==='true';
    var mobile=document.querySelector('#pr-mobile-menu');
    var images=Object.create(null);
    if(shown&&mobile){
      mobile.querySelectorAll('.pr-menu-category,.pr-menu-subcategory').forEach(function(link){
        var title=link.querySelector('span:not([aria-hidden])');
        var image=link.querySelector('img[src]');
        if(!title||!image)return;
        var key=normalizeTitle(title.textContent);
        if(key&&!images[key])images[key]=image.getAttribute('src');
      });
    }
    root.querySelectorAll('[data-prm-photo-title]').forEach(function(link){
      var slot=link.querySelector('.prm-desktop-nav__photo');
      if(!slot)return;
      var src=shown&&images[normalizeTitle(link.getAttribute('data-prm-photo-title'))];
      if(!src){
        slot.hidden=true;
        slot.replaceChildren();
        return;
      }
      var img=slot.querySelector('img');
      if(!img || img.getAttribute('src')!==src){
        img=document.createElement('img');
        img.alt='';
        img.loading='lazy';
        img.decoding='async';
        img.width=100;
        img.height=78;
        img.src=src;
        slot.replaceChildren(img);
      }
      slot.hidden=false;
    });
  }
  /* Fit the open dropdown into the ACTUAL visible space below its header.
     The previous 86vh limit could leave the bottom and scrollbar off-screen,
     especially on shorter laptop displays. Also keep its right edge in view. */
  function fitMegaPanel(){
    var root=getSection();
    if(!root||root.hidden)return;
    var shop=root.querySelector('.prm-desktop-nav__shop');
    if(!shop||!shop.open)return;
    var panel=shop.querySelector('.prm-desktop-nav__mega');
    if(!panel)return;
    // Measure from the menu's natural anchor, not last resize's shifted left.
    panel.style.removeProperty('left');
    var rect=panel.getBoundingClientRect();
    if(rect.width<1)return;
    var edge=12;
    var visibleWidth=document.documentElement.clientWidth||window.innerWidth;
    var shift=Math.min(Math.max(0,rect.right-(visibleWidth-edge)),Math.max(0,rect.left-edge));
    if(shift>0)panel.style.left='-'+Math.ceil(shift)+'px';
    var top=panel.getBoundingClientRect().top;
    var visibleHeight=window.visualViewport?window.visualViewport.height:window.innerHeight;
    var remaining=Math.max(120,Math.floor(visibleHeight-top-edge));
    panel.style.maxHeight=Math.min(760,remaining)+'px';
    panel.style.overflowY='auto';
  }
  function apply(){
    var root=getSection();
    if(!root)return;
    if(!window.matchMedia('(min-width:1025px)').matches){revert();return;}
    var header=document.querySelector('header.headertype2 .tt-desktop-header');
    var target=header&&header.querySelector('.single-menu .tt-header-holder .tt-obj-menu');
    var legacy=target&&target.querySelector('.tt-desctop-parent-menu');
    if(!target||!legacy){revert();return;}
    if(!originalParent||!originalParent.isConnected){originalParent=root.parentNode;originalNext=root.nextSibling;}
    if(root.parentNode!==target)target.appendChild(root);
    root.hidden=false;
    syncMobilePhotos(root);
    target.classList.add('prm-desktop-nav-mounted');
    fitMegaPanel();
    holder=target;place=root;
  }
  function launchVideo(button){
    var root=getSection();
    if(!root||root.hidden||!root.contains(button))return;
    var id=(button.getAttribute('data-prm-video-id')||'').trim();
    if(!/^[a-zA-Z0-9_-]{11}$/.test(id))return;
    stopVideos(root);
    var title=(button.getAttribute('aria-label')||'Performance Reel video').replace(/^Play\s+/i,'');
    videoModalReturnFocus=button;
    videoModalPriorOverflow=document.body.style.overflow;
    var overlay=document.createElement('div');
    overlay.className='prm-desktop-nav__modal';
    var dialog=document.createElement('div');
    dialog.className='prm-desktop-nav__modal-dialog';
    dialog.setAttribute('role','dialog');
    dialog.setAttribute('aria-modal','true');
    dialog.setAttribute('aria-label',title);
    var header=document.createElement('div');
    header.className='prm-desktop-nav__modal-top';
    var heading=document.createElement('strong');
    heading.className='prm-desktop-nav__modal-title';
    heading.textContent=title;
    var close=document.createElement('button');
    close.className='prm-desktop-nav__modal-close';
    close.type='button';
    close.setAttribute('aria-label','Close video');
    close.textContent='\u00d7';
    header.appendChild(heading);
    header.appendChild(close);
    var frame=document.createElement('div');
    frame.className='prm-desktop-nav__modal-video';
    var iframe=document.createElement('iframe');
    iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
    iframe.title=title;
    iframe.setAttribute('allow','accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen','');
    iframe.setAttribute('referrerpolicy','strict-origin-when-cross-origin');
    frame.appendChild(iframe);
    dialog.appendChild(header);
    dialog.appendChild(frame);
    overlay.appendChild(dialog);
    overlay.addEventListener('click',function(e){
      e.stopPropagation();
      if(e.target===overlay||e.target.closest('.prm-desktop-nav__modal-close')){
        closeVideoModal();
      }
    });
    overlay.addEventListener('keydown',function(e){
      if(e.key==='Escape'){
        e.preventDefault();e.stopPropagation();closeVideoModal();
      }else if(e.key==='Tab'){
        // The video iframe and close button are the focusable controls.
        var targets=[close,iframe];
        if(e.shiftKey&&document.activeElement===close){
          e.preventDefault();iframe.focus();
        }else if(!e.shiftKey&&document.activeElement===iframe){
          e.preventDefault();close.focus();
        }
      }
    });
    document.body.appendChild(overlay);
    videoModal=overlay;
    document.body.style.overflow='hidden';
    close.focus({preventScroll:true});
  }
  function installInteractions(){
    document.addEventListener('click',function(e){
      var play=e.target.closest&&e.target.closest('.prm-desktop-nav__video-play');
      if(play){
        e.preventDefault();
        launchVideo(play);
        return;
      }
      var root=getSection();if(!root||root.hidden||root.contains(e.target))return;
      closeMenus(root);
    });
    document.addEventListener('toggle',function(e){
      var root=getSection();
      if(root && e.target.matches && e.target.matches('.prm-desktop-nav__shop')){
        if(e.target.open)fitMegaPanel();
        else stopVideos(root);
      }
    },true);
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){
        if(closeVideoModal())return;
        closeMenus(getSection());
      }
    });
    document.addEventListener('shopify:section:load',apply);
    document.addEventListener('shopify:section:reorder',apply);
    window.addEventListener('resize',apply);
    window.addEventListener('pageshow',apply);
    window.addEventListener('scroll',fitMegaPanel,{passive:true});
    if(window.visualViewport)window.visualViewport.addEventListener('resize',fitMegaPanel);
    /* Only open after entering the SHOP control from outside it.
       Child-to-child pointer movement should never flip the details state.
       Delay closing so the cursor can cross the menu-panel boundary safely. */
    var hover=window.matchMedia('(hover:hover) and (pointer:fine)');
    var hoverCloseTimer=null;
    function clearHoverClose(){
      if(hoverCloseTimer!==null){
        window.clearTimeout(hoverCloseTimer);
        hoverCloseTimer=null;
      }
    }
    document.addEventListener('pointerover',function(e){
      if(!hover.matches)return;
      var root=getSection(),shop=root&&!root.hidden&&root.querySelector('.prm-desktop-nav__shop');
      if(!shop||!shop.contains(e.target))return;
      clearHoverClose();
      if(!shop.contains(e.relatedTarget)){
        shop.open=true;
        fitMegaPanel();
      }
    });
    document.addEventListener('pointerout',function(e){
      if(!hover.matches)return;
      var root=getSection(),shop=root&&!root.hidden&&root.querySelector('.prm-desktop-nav__shop');
      if(videoModal||!shop||!shop.contains(e.target)||shop.contains(e.relatedTarget))return;
      clearHoverClose();
      hoverCloseTimer=window.setTimeout(function(){
        hoverCloseTimer=null;
        if(!videoModal&&shop.isConnected&&!shop.matches(':hover'))shop.open=false;
      },200);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);
  else apply();
  installInteractions();
})();